import {createSignal} from '@pexip/signal';

import type {ImageRecord} from '../types';

export const userCustomImageSignal = createSignal<ImageRecord | undefined>();
